import { isNullOrUndefined } from "../../../common/utils";

export function heightOfNode(conditionNode) {
  if (isNullOrUndefined(conditionNode.parent)) {
    return 0;
  }
  return heightOfNode(conditionNode.parent) + 1;
}
